export default __webpack_public_path__ + "static/media/21.63dd1bc9.png";